module.exports = "\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/auth.component.html
// module id = ./src/app/auth/auth.component.html
// module chunks = main